module.exports = __webpack_public_path__ + "static/media/push.4c5cf500.wav";